export default __webpack_public_path__ + "static/media/Foto-02.c7a7ad28.png";